/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
// import scriptLoader from 'react-async-script-loader';
import { node } from 'prop-types';
import withScript from '../../../../lib/scriptLoader';

import { cardIslePluginConfig } from '../../../../state/ducks/Checkout/ducks/Recipient/ducks/CardIsle/CardIsle-Helpers';

const { cardIsleGiftCardsURL } = cardIslePluginConfig;

const LoadCardIsleLib = ({ children }) => <>{children}</>;

LoadCardIsleLib.propTypes = {
    children: node,
};

LoadCardIsleLib.defaultProps = {
    children: null,
};

export default withScript(cardIsleGiftCardsURL, false, false)(LoadCardIsleLib);
